import { render, staticRenderFns } from "./AssignListItem.vue?vue&type=template&id=df07e0a8&scoped=true&"
import script from "./AssignListItem.vue?vue&type=script&lang=js&"
export * from "./AssignListItem.vue?vue&type=script&lang=js&"
import style0 from "./AssignListItem.vue?vue&type=style&index=0&id=df07e0a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df07e0a8",
  null
  
)

export default component.exports